import script from "./TravelerModalityChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TravelerModalityChart.vue?vue&type=script&setup=true&lang=ts"

import "./TravelerModalityChart.vue?vue&type=style&index=0&id=35655283&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35655283"]])

export default __exports__